export default __webpack_public_path__ + "static/media/checkbox-square.7af6d356.svg";